// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmDeleteModal_customerTitle__gTJdc","customerLabel":"ConfirmDeleteModal_customerLabel__-iepO","customerBtn":"ConfirmDeleteModal_customerBtn__9GcFJ"};